import { StrategyBuilderFunction, EMPTY_STRATEGY } from './types';
import { addLongCall, addShortCall } from './addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  getStrategyLegStrikeDirection,
  getStrikeDistance,
} from './utils';

export const shortCallButterfly: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  const lowerStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: -2 }),
  );
  const atTheMoneyStrike = findClosestStrikePrice(strikesAtExpiration, spot);
  const upperStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: 2 }),
  );

  return {
    optionPositions: [
      addShortCall({
        strike: lowerStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[lowerStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[lowerStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      addLongCall({
        strike: atTheMoneyStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[atTheMoneyStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[atTheMoneyStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 2 * contractMultiplier, // Selling two at-the-money calls
      }),
      addShortCall({
        strike: upperStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[upperStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[upperStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
    ],
    stockPositions: [],
  };
};
